module.exports = __webpack_public_path__ + "static/media/Calendar.31e1de15.svg";